import { render, staticRenderFns } from "./Planos.vue?vue&type=template&id=e18f4710&"
import script from "./Planos.vue?vue&type=script&lang=js&"
export * from "./Planos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports